import { connect } from '@/common/lib/riot-redux';
import SearchSelectEdit from './search-select-edit.riot';

/* このファイルは props の参考のため */
const mapStateToProps = (state, props) => {
  /**
   * item の一覧
   * @type {any[]}
   */
  const itemList = props.itemList;

  /**
   * 削除済みの item の一覧
   * @type {any[]}
   */
  const invalidItemList = props.invalidItemList ?? [];
  
  /**
   * 現在の value, getId から取得したものと同じ
   */
  const value = props.value;

  /**
   * チェックボックスの状態をキープするか
   * （true だと、同じアイテムの2回目のクリックは解除扱い、false だと何度クリックしても選択扱い）
   * @type {boolean}
   */
  const unselectable = props.unselectable != null ? true : false;

  /**
   * item が選択された時の callback
   * @type {(itemId: string) => void}
   */
  const onChange = props.onChange;

  /**
   * 一覧で表示する item のラベル。
   * 検索フィルターに含まれているかにも使われる。
   * @type {(item: any) => string}
   */
  const getLabel = props.getLabel;

  /**
   * item の unique id
   * @type {(item: any) => string}
   */
  const getId = props.getId;

  /**
   * item がフィルターに引っかかるか
   * @type {(item: any, filter: string) => boolean}
   */
  const checkMatch = props.checkMatch;

  /**
   * テキスト入力欄の handler
   * @type {(e: Event) => void}
   */
  const onEditChange = props.onEditChange;

  /**
   * 選択肢にマウスまたはキーボードでフォーカスした時の callback
   * @type {((item: any, anchor: HTMLElement) => void) | undefined}
   */
  const onItemEnter = props.onItemEnter;

  /**
   * 選択肢からマウスが離れた時の callback
   * @type {((item: any) => void) | undefined}
   */
  const onItemLeave = props.onItemLeave;

  /**
   * 選択肢メニューを閉じた時の callback
   * @type {(() => void) | undefined}
   */
  const onMenuClose = props.onMenuClose;

  const itemById = itemList.reduce((map, item) => {
    map[getId(item)] = item;
    return map;
  }, {});

  const itemByLabel = itemList.reduce((map, item) => {
    map[getLabel(item)] = item;
    return map;
  }, {});

  const invalidItemById = invalidItemList.reduce((map, item) => {
    map[getId(item)] = item;
    return map;
  }, {});

  const invalidItemByLabel = invalidItemList.reduce((map, item) => {
    map[getLabel(item)] = item;
    return map;
  }, {});



  return {
    ...props,
    itemList,
    invalidItemList,
    value,
    unselectable,
    itemById,
    itemByLabel,
    invalidItemById,
    invalidItemByLabel,
    onChange,
    getLabel,
    getId,
    checkMatch,
    onEditChange,
    onItemEnter,
    onItemLeave,
    onMenuClose,
  };
};

export default connect(SearchSelectEdit, mapStateToProps);